import React from 'react'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import CustomerServiceLayoutDefault from '../layout/default'
import CSHeader from '../partials/header'
import TeaserLinks from '../partials/teaser-links'
import InteractionStudioContent from '../../../components/interaction-studio/content'
import ContentSlot from '../../../components/content-slot'

const CustomerServiceOverviewPage = () => {
    const pageConfig = useCustomerServicePageConfig()
    const {id, name, description, content} = pageConfig

    return (
        <CustomerServiceLayoutDefault>
            <CSHeader headline={name} subline={description}></CSHeader>
            <InteractionStudioContent id="is-customer-service-middle">
                <ContentSlot
                    context="folder"
                    contextId={id}
                    disableSkeleton
                    slotId="customer-service-middle"
                    showError={false}
                    variant="cms"
                />
            </InteractionStudioContent>
            <TeaserLinks links={content?.linklist} />
        </CustomerServiceLayoutDefault>
    )
}

export default CustomerServiceOverviewPage
